import { render, staticRenderFns } from "./AppSubmitButton.vue?vue&type=template&id=23e21030&scoped=true&"
import script from "./AppSubmitButton.vue?vue&type=script&lang=js&"
export * from "./AppSubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e21030",
  null
  
)

export default component.exports